// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-experiences__achievements-form,
.profile-experiences__trajectory-form {
    padding: 0px 40px;
}

.profile-experiences__container .baloa-table-column {
    color: var(--primary-very-dark-color);
    margin: 30px 40px 0 40px;
}

.experience-form__form__fields-group {
    display: grid;
    grid-template-columns:  1fr 1fr;
    grid-gap: var(--space-and-half);
}
.experience-form__form__fields-group .input-field {
    margin: 0;
}
.experience-form__form__actions {
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    border-top: 1px solid var(--new-gray-background-color);
    padding: 16px;
}

.experiences-modal-tabs {
    background: var(--white-color);
}

.profile-experiences__upload-gallery .baloa-table-column {
    color: var(--primary-very-dark-color);
    margin: 0 0 4px 0;
}

.profile-experiences__upload-gallery .baloa-username {
    color: var(--basic-gray-color);
    margin-bottom: 12px;
}

.profile-experiences__upload-gallery .secondary-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.profile-experiences__team-logo__container {
    margin: 20px 0 40px 0;
}

.profile-experiences__team-logo__logo span.hubicon-default_pp {
    font-size: 70px;
}

.profile-experiences__team-logo__logo {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
}

.profile-experiences__team-logo__logo .hubicon-add_option {
    background-color: var(--new-green-color);
    position: absolute;
    border-radius: 50%;
    top: 43px;
    left: 52%;
    color: var(--white-color);
    padding: 3px;
    cursor: pointer;
}

.profile-experiences__team-logo__logo img {
    width: 70px;
    height: 70px;
    border-radius: 50%;
}

.profile-experiences__team-logo__upload-img.baloa-table-column {
    color: var(--new-green-color);
    text-align: center;
    font-weight: var(--font-bold);
    margin-top: 8px;
    cursor: pointer;
}

.profile-experiences__achievements-form .input-field-label,
.profile-experiences__achievements-form .input-field-input,
.profile-experiences__achievements-form .input-field-multiline-label,
.profile-experiences__trajectory-form .input-field-label,
.profile-experiences__trajectory-form .input-field-input,
.profile-experiences__trajectory-form .input-field-multiline-label {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: calc(var(--space-half-quarter) + var(--space-eighth));
    line-height: var(--space);
    color: var(--primary-very-dark-color);
    background-color: transparent;

}

.profile-experiences__achievements-form .input-field-multiline-input,
.profile-experiences__trajectory-form .input-field-multiline-input {
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
}

.profile-experiences__achievements-form .input-field-multiline {
    margin: 20px 0;
}

.profile-experiences__trajectory-form .input-field-multiline {
    margin: 0 0 20px 0;
}

.profile-experiences__achievements-form .input-field-input,
.profile-experiences__trajectory-form .input-field-input {
    border: 1px solid var(--new-gray-background-color);
}

.experience-form__form__fields-date {
    position: relative;
    display: flex;
    
    
}

.experience-form__form__fields-date .hubicon-date {
    position: absolute;
    left: 170px;
    color: var(--primary-dark-color);
    top: 12px;
}

.experience-form__form__fields-date .hubicon-date.disabled {
    color: var(--new-gray-background-color);
}

.profile-experiences__upload-gallery__add {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    margin-top: 10px;
}

.profile-experiences__upload-gallery__add .profile-experiences__upload-gallery__add-img {
    width: 160px;
    height: 107px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
}

.profile-experiences__upload-gallery__add .profile-experiences__upload-gallery__add-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.profile-experiences__upload-gallery__add .profile-experiences__upload-gallery__add-img .hubicon-clear_option {
    position: absolute;
    font-size: 16px;
    padding: 4px;
    border-radius: 50%;
    background-color: var(--new-input-background-color);
    top: 6px;
    right: 6px;
    cursor: pointer;
}

.experience-form__form__fields-group.experience-form__form__fields-date__container {
    display: flex;
    align-items: center;
    gap: 45px;
}

.experience-form__form__trajectory__check-input.checkbox-field {
    margin: 0 0 34px 0;
}

.experience-form__form__trajectory__check-input .checkbox-field__content {
    align-items: center;
    justify-content: center;
}

.experience-form__form__trajectory__check-input .checkbox-field__sub-message {
    margin: 0;
    font-weight: var(--font-regular);
    font-size: 15px;
    color: var(--primary-very-dark-color);
}

.profile-experiences__trajectory-form .input-field.experience-form__form__input {
    margin-bottom: 24px;
}

.experience-form__form__input.disabled .input-field-input{
    color: var(--new-gray-background-color);
}

.experience-form__form__trajectory__check-input .baloa-table-column {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.experience-form__form__trajectory__check-input .checkbox-field__content .baloa-table-column {
    margin: 0
}

@media screen and (max-width: 1440px){
    .profile-experiences__modal-container .modal2__container {
        width: 40%;
    }
}

@media screen and (max-width: 992px){
    .profile-experiences__modal-container .modal2__container {
        width: 60%;
    }
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 

    .profile-experiences__modal-container .modal2__container{
        margin: 0;
        border-radius: 0;
        height: 100%;
        max-height: 100%;
        width: 100%;
    }

    .profile-experiences__modal-container .modal2__content{
        overflow: hidden;
    }

    .profile-experiences__container {
        height: 100vh;
    }

    .experience-form__form__actions {
        margin-top: 0;
        position: absolute;
        bottom: 0;
    }

    .profile-experiences__achievements-form, .profile-experiences__trajectory-form {
        padding: 0px 16px;
    }

    .profile-experiences__container .baloa-table-column {
        margin: 30px 16px 0 16px;
    }

    .experience-form__form__fields-date .hubicon-date {
        left: 130px;
    }    

    .experience-form__form.form {
        height: 100%;
        margin-bottom: 70px;
    }

    .profile-experiences__upload-gallery .baloa-table-column {
        margin: 0%;
        margin-bottom: 4px;
    }

    .profile-experiences__upload-gallery__add .profile-experiences__upload-gallery__add-img {
        width: 108px;
        height: 100px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-experiences-modal/ProfileExperiencesModalComponent.styles.css"],"names":[],"mappings":"AAAA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,+BAA+B;AACnC;AACA;IACI,SAAS;AACb;AACA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,sDAAsD;IACtD,aAAa;AACjB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,eAAe;AACnB;;AAEA;;;;;;IAMI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,gEAAgE;IAChE,yBAAyB;IACzB,qCAAqC;IACrC,6BAA6B;;AAEjC;;AAEA;;IAEI,oCAAoC;IACpC,kDAAkD;AACtD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;IAClB,aAAa;;;AAGjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,mDAAmD;IACnD,QAAQ;IACR,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,SAAS;QACT,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;AACJ","sourcesContent":[".profile-experiences__achievements-form,\n.profile-experiences__trajectory-form {\n    padding: 0px 40px;\n}\n\n.profile-experiences__container .baloa-table-column {\n    color: var(--primary-very-dark-color);\n    margin: 30px 40px 0 40px;\n}\n\n.experience-form__form__fields-group {\n    display: grid;\n    grid-template-columns:  1fr 1fr;\n    grid-gap: var(--space-and-half);\n}\n.experience-form__form__fields-group .input-field {\n    margin: 0;\n}\n.experience-form__form__actions {\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 30px;\n    border-top: 1px solid var(--new-gray-background-color);\n    padding: 16px;\n}\n\n.experiences-modal-tabs {\n    background: var(--white-color);\n}\n\n.profile-experiences__upload-gallery .baloa-table-column {\n    color: var(--primary-very-dark-color);\n    margin: 0 0 4px 0;\n}\n\n.profile-experiences__upload-gallery .baloa-username {\n    color: var(--basic-gray-color);\n    margin-bottom: 12px;\n}\n\n.profile-experiences__upload-gallery .secondary-button {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n}\n\n.profile-experiences__team-logo__container {\n    margin: 20px 0 40px 0;\n}\n\n.profile-experiences__team-logo__logo span.hubicon-default_pp {\n    font-size: 70px;\n}\n\n.profile-experiences__team-logo__logo {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    cursor: pointer;\n}\n\n.profile-experiences__team-logo__logo .hubicon-add_option {\n    background-color: var(--new-green-color);\n    position: absolute;\n    border-radius: 50%;\n    top: 43px;\n    left: 52%;\n    color: var(--white-color);\n    padding: 3px;\n    cursor: pointer;\n}\n\n.profile-experiences__team-logo__logo img {\n    width: 70px;\n    height: 70px;\n    border-radius: 50%;\n}\n\n.profile-experiences__team-logo__upload-img.baloa-table-column {\n    color: var(--new-green-color);\n    text-align: center;\n    font-weight: var(--font-bold);\n    margin-top: 8px;\n    cursor: pointer;\n}\n\n.profile-experiences__achievements-form .input-field-label,\n.profile-experiences__achievements-form .input-field-input,\n.profile-experiences__achievements-form .input-field-multiline-label,\n.profile-experiences__trajectory-form .input-field-label,\n.profile-experiences__trajectory-form .input-field-input,\n.profile-experiences__trajectory-form .input-field-multiline-label {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth));\n    line-height: var(--space);\n    color: var(--primary-very-dark-color);\n    background-color: transparent;\n\n}\n\n.profile-experiences__achievements-form .input-field-multiline-input,\n.profile-experiences__trajectory-form .input-field-multiline-input {\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.profile-experiences__achievements-form .input-field-multiline {\n    margin: 20px 0;\n}\n\n.profile-experiences__trajectory-form .input-field-multiline {\n    margin: 0 0 20px 0;\n}\n\n.profile-experiences__achievements-form .input-field-input,\n.profile-experiences__trajectory-form .input-field-input {\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.experience-form__form__fields-date {\n    position: relative;\n    display: flex;\n    \n    \n}\n\n.experience-form__form__fields-date .hubicon-date {\n    position: absolute;\n    left: 170px;\n    color: var(--primary-dark-color);\n    top: 12px;\n}\n\n.experience-form__form__fields-date .hubicon-date.disabled {\n    color: var(--new-gray-background-color);\n}\n\n.profile-experiences__upload-gallery__add {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n.profile-experiences__upload-gallery__add .profile-experiences__upload-gallery__add-img {\n    width: 160px;\n    height: 107px;\n    border-radius: 8px;\n    overflow: hidden;\n    position: relative;\n}\n\n.profile-experiences__upload-gallery__add .profile-experiences__upload-gallery__add-img img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.profile-experiences__upload-gallery__add .profile-experiences__upload-gallery__add-img .hubicon-clear_option {\n    position: absolute;\n    font-size: 16px;\n    padding: 4px;\n    border-radius: 50%;\n    background-color: var(--new-input-background-color);\n    top: 6px;\n    right: 6px;\n    cursor: pointer;\n}\n\n.experience-form__form__fields-group.experience-form__form__fields-date__container {\n    display: flex;\n    align-items: center;\n    gap: 45px;\n}\n\n.experience-form__form__trajectory__check-input.checkbox-field {\n    margin: 0 0 34px 0;\n}\n\n.experience-form__form__trajectory__check-input .checkbox-field__content {\n    align-items: center;\n    justify-content: center;\n}\n\n.experience-form__form__trajectory__check-input .checkbox-field__sub-message {\n    margin: 0;\n    font-weight: var(--font-regular);\n    font-size: 15px;\n    color: var(--primary-very-dark-color);\n}\n\n.profile-experiences__trajectory-form .input-field.experience-form__form__input {\n    margin-bottom: 24px;\n}\n\n.experience-form__form__input.disabled .input-field-input{\n    color: var(--new-gray-background-color);\n}\n\n.experience-form__form__trajectory__check-input .baloa-table-column {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.experience-form__form__trajectory__check-input .checkbox-field__content .baloa-table-column {\n    margin: 0\n}\n\n@media screen and (max-width: 1440px){\n    .profile-experiences__modal-container .modal2__container {\n        width: 40%;\n    }\n}\n\n@media screen and (max-width: 992px){\n    .profile-experiences__modal-container .modal2__container {\n        width: 60%;\n    }\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n\n    .profile-experiences__modal-container .modal2__container{\n        margin: 0;\n        border-radius: 0;\n        height: 100%;\n        max-height: 100%;\n        width: 100%;\n    }\n\n    .profile-experiences__modal-container .modal2__content{\n        overflow: hidden;\n    }\n\n    .profile-experiences__container {\n        height: 100vh;\n    }\n\n    .experience-form__form__actions {\n        margin-top: 0;\n        position: absolute;\n        bottom: 0;\n    }\n\n    .profile-experiences__achievements-form, .profile-experiences__trajectory-form {\n        padding: 0px 16px;\n    }\n\n    .profile-experiences__container .baloa-table-column {\n        margin: 30px 16px 0 16px;\n    }\n\n    .experience-form__form__fields-date .hubicon-date {\n        left: 130px;\n    }    \n\n    .experience-form__form.form {\n        height: 100%;\n        margin-bottom: 70px;\n    }\n\n    .profile-experiences__upload-gallery .baloa-table-column {\n        margin: 0%;\n        margin-bottom: 4px;\n    }\n\n    .profile-experiences__upload-gallery__add .profile-experiences__upload-gallery__add-img {\n        width: 108px;\n        height: 100px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
